import '../assets/NcDateTimePickerNative-DnLJu29_.css';
import { n as f } from "../chunks/_plugin-vue2_normalizer-Bj5bLKV4.mjs";
import { S as h } from "../chunks/ScopeComponent-CGJeYf1D.mjs";
const p = ["date", "datetime-local", "month", "time", "week"], c = {
  name: "NcDateTimePickerNative",
  inheritAttrs: !1,
  props: {
    /**
     * The date is – like the `Date` object in JavaScript – tied to UTC.
     * The selected time zone does not have an influence of the selected time and date value.
     * You have to translate the time yourself when you want to factor in time zones.
     * Pass null to clear the input field.
     */
    value: {
      type: Date,
      default: null
    },
    /**
     * id attribute of the input field
     */
    id: {
      type: String,
      required: !0
    },
    /**
     * type attribute of the input field
     * default type: String
     * The type of the input element, it can be `date`, `datetime-local`, `month`, `time`, `week`
     */
    type: {
      type: String,
      default: "date",
      validate: (e) => p.includes(e)
    },
    /**
     * text inside the label element
     * default type: String
     */
    label: {
      type: String,
      default: "Please choose a date"
    },
    /**
     * min attribute of the input field
     * default type: null
     */
    min: {
      type: [Date, Boolean],
      default: null
    },
    /**
     * max attribute of the input field
     * default type: null
     */
    max: {
      type: [Date, Boolean],
      default: null
    },
    /**
     * Flag to hide the label
     * default type: String
     * The hidden input label for accessibility purposes.
     */
    hideLabel: {
      type: Boolean,
      default: !1
    },
    /**
     * Class to add to the input field.
     * Necessary to use NcDateTimePickerNative in the NcActionInput component.
     */
    inputClass: {
      type: [Object, String],
      default: ""
    }
  },
  emits: [
    "input"
  ],
  computed: {
    formattedValue() {
      return this.formatValue(this.value);
    },
    formattedMin() {
      return this.min ? this.formatValue(this.min) : !1;
    },
    formattedMax() {
      return this.max ? this.formatValue(this.max) : !1;
    },
    listeners() {
      return {
        ...this.$listeners,
        /**
         * Handle the input event
         *
         * @param {InputEvent} $event input event payload
         * @return {Date|string} new chosen Date() or an empty string
         */
        input: (e) => {
          if (isNaN(e.target.valueAsNumber))
            return this.$emit("input", null);
          if (this.type === "time") {
            const i = e.target.value;
            if (this.value === "") {
              const { yyyy: l, MM: o, dd: u } = this.getReadableDate(/* @__PURE__ */ new Date());
              return this.$emit("input", new Date("".concat(l, "-").concat(o, "-").concat(u, "T").concat(i)));
            }
            const { yyyy: n, MM: s, dd: r } = this.getReadableDate(this.value);
            return this.$emit("input", new Date("".concat(n, "-").concat(s, "-").concat(r, "T").concat(i)));
          } else if (this.type === "month") {
            const i = (new Date(e.target.value).getMonth() + 1).toString().padStart(2, "0");
            if (this.value === "") {
              const { yyyy: o, dd: u, hh: m, mm: d } = this.getReadableDate(/* @__PURE__ */ new Date());
              return this.$emit("input", new Date("".concat(o, "-").concat(i, "-").concat(u, "T").concat(m, ":").concat(d)));
            }
            const { yyyy: n, dd: s, hh: r, mm: l } = this.getReadableDate(this.value);
            return this.$emit("input", new Date("".concat(n, "-").concat(i, "-").concat(s, "T").concat(r, ":").concat(l)));
          }
          const t = new Date(e.target.valueAsNumber).getTimezoneOffset() * 1e3 * 60, a = e.target.valueAsNumber + t;
          return this.$emit("input", new Date(a));
        }
      };
    }
  },
  methods: {
    /**
     * Returns Object with string values of a Date
     *
     * @param {Date} value The selected value
     * @return {object|undefined}
     */
    getReadableDate(e) {
      if (e instanceof Date) {
        const t = e.getFullYear().toString().padStart(4, "0"), a = (e.getMonth() + 1).toString().padStart(2, "0"), i = e.getDate().toString().padStart(2, "0"), n = e.getHours().toString().padStart(2, "0"), s = e.getMinutes().toString().padStart(2, "0");
        return { yyyy: t, MM: a, dd: i, hh: n, mm: s };
      }
    },
    /**
     * Returns preformatted value for the input field
     *
     * @param {Date} value The selected value
     * @return {string|undefined}
     */
    formatValue(e) {
      if (e instanceof Date) {
        const { yyyy: t, MM: a, dd: i, hh: n, mm: s } = this.getReadableDate(e);
        if (this.type === "datetime-local")
          return "".concat(t, "-").concat(a, "-").concat(i, "T").concat(n, ":").concat(s);
        if (this.type === "date")
          return "".concat(t, "-").concat(a, "-").concat(i);
        if (this.type === "month")
          return "".concat(t, "-").concat(a);
        if (this.type === "time")
          return "".concat(n, ":").concat(s);
        if (this.type === "week") {
          const r = new Date(t, 0, 1), l = Math.floor((e - r) / (24 * 60 * 60 * 1e3)), o = Math.ceil(l / 7);
          return "".concat(t, "-W").concat(o);
        }
      } else
        return "";
    }
  }
};
var y = function() {
  var t = this, a = t._self._c;
  return a("div", { staticClass: "native-datetime-picker" }, [a("label", { class: { "hidden-visually": t.hideLabel }, attrs: { for: t.id } }, [t._v(t._s(t.label))]), a("input", t._g(t._b({ staticClass: "native-datetime-picker--input", class: t.inputClass, attrs: { id: t.id, type: t.type, min: t.formattedMin, max: t.formattedMax }, domProps: { value: t.formattedValue } }, "input", t.$attrs, !1), t.listeners))]);
}, $ = [], g = /* @__PURE__ */ f(
  c,
  y,
  $,
  !1,
  null,
  "7b246f90",
  null,
  null
);
const D = g.exports;
/**
 * @copyright Copyright (c) 2022 Julia Kirschenheuter <julia.kirschenheuter@nextcloud.com>
 *
 * @author Julia Kirschenheuter <julia.kirschenheuter@nextcloud.com>
 *
 * @license AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */
h(D);
export {
  D as default
};
